import { render, staticRenderFns } from "./penalties_and_tenders.vue?vue&type=template&id=3280ef67&"
import script from "./penalties_and_tenders.vue?vue&type=script&lang=js&"
export * from "./penalties_and_tenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports